<template>
  <v-container fluid class="list-sor">
    <v-row class="flex-grow-0">
      <h3>{{ $t("app_drawer.rbu_datasets") }}</h3>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="ml-4" small @click="createDataset">
        <v-icon>mdi-plus</v-icon>
        {{ $t("new") }}
      </v-btn>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col>
        <DatasetList
          full-height
          :refresh-trigger.sync="refreshTrigger"
        ></DatasetList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref } from "@vue/composition-api";
import SorList from "@/components/sor/SorList.vue";
import { PERMISSIONS } from "@/constants";
import DatasetList from "@/components/dataset/DatasetList.vue";
import CreateDatasetDialog from "@/components/dataset/CreateDatasetDialog.vue";

export default {
  name: "SoRs",
  components: { DatasetList, SorList },
  setup(props, { root }) {
    const createDataset = async function () {
      const datasetId = await root.$dialog.showAndWait(CreateDatasetDialog, {
        showClose: false,
        persistent: true,
      });

      if (datasetId) {
        root.$router.push({ name: "rbu-dataset", params: { datasetId } });
      }
    };

    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    return {
      createDataset,

      refreshTrigger,
      refresh,

      PERMISSIONS,
    };
  },
};
</script>

<style lang="less">
.list-sor {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
